import { render, staticRenderFns } from "./SimpleCheckbox.vue?vue&type=template&id=aeb31e9c&"
import script from "./SimpleCheckbox.vue?vue&type=script&lang=ts&"
export * from "./SimpleCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports